import React, { useEffect, useRef, useState } from 'react'
import DatePicker from "react-datepicker";

import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';
import { BlueDatePickerProperties } from './DatePickerBlueColor';

import Icon from "components/Varios/Icons.js";

registerLocale('ES', es)
type PropsMonthDatePicker = {
    onChange: (date: any) => void,
    maxDate?: string | null,
    minDate?: string | null,
    color?: "default" | "blue"
    value?: any
    placeholderText?:string
}



export default function MonthDatePicker(props: PropsMonthDatePicker) {

    const [startDate, setstartDate] = useState<Date|undefined>(props.value)

   
    useEffect(() => {
      setstartDate(props.value)
    }, [props.value])
    

    const dateInputRef = useRef<any | null>(null);


    function HandleChange(date) {

        props.onChange(date);
        setstartDate(date)
    }



    function HandleStylesColor(color: "default" | "blue" | undefined) {

        const defaultStylesIcon: React.CSSProperties = {
            backgroundColor: "#FFC200"
        }

        if (color === undefined || color !== undefined && color === "default") {
            return defaultStylesIcon
        }
        else if (color === "blue") {
            return BlueDatePickerProperties().Istyles;
        }
        else {
            return defaultStylesIcon
        }
    }

    function HandleFillColor(color: "default" | "blue" | undefined) {
        const defaultFillColor: string = "#FFFFFF";

        if (color === undefined || color !== undefined && color === "default") {
            return defaultFillColor
        }
        else if (color === "blue") {
            return BlueDatePickerProperties().IfillColor;
        }
        else {
            return defaultFillColor
        }
    }

    function ToogleActive () {
        if(dateInputRef.current ){
            dateInputRef.current.input.click();
        }
    }

    return (
        <div className='input-group'>

            <DatePicker
                ref={dateInputRef}
                selected={startDate}
                onChange={(date) => HandleChange(date)}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                showFullMonthYearPicker
                locale="ES"
                maxDate={props.maxDate ? new Date(props.maxDate) : null}
                minDate={props.minDate ? new Date(props.minDate) : null}
                utcOffset={"America/Guayaquil"}
                autoComplete="off"
                customInput={<input style={{borderTopLeftRadius:"5px", borderBottomLeftRadius: "5px",  borderColor: "#517ED3"}} className="no_autocomplete form-control" autoComplete="off"></input>}
                placeholderText={props.placeholderText ? props.placeholderText : ""}
            />
            <div className="input-group-append " style={HandleStylesColor(props.color)}>
                <Icon kind="calendario" fill={HandleFillColor(props.color)} width={27} height={27} onClick={() => ToogleActive()} />
            </div>
        </div>

    )
}
